import { ApiLogger } from '../../utils';
import { useQuery } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { orderBy } from './types';
const useEscrowDetailsQuery = _ref => {
  let {
    url,
    xApiKey,
    loanNumber,
    authToken,
    logApiEvent,
    select
  } = _ref;
  const correlationId = uuid.v4().toString();
  const config = {
    method: 'get',
    url,
    headers: {
      'Authorization': `Bearer ${authToken}`,
      'applicationName': 'web',
      'x-correlation-id': correlationId,
      'x-api-key': xApiKey
    }
  };
  return useQuery({
    queryKey: ['fetch-escrow-details', loanNumber],
    queryFn: async () => ApiLogger(logApiEvent, config),
    select,
    enabled: !!(authToken && url)
  });
};
const escrowSummaryEntityAdapter = responseDetails => {
  if (responseDetails) {
    const breakouts = Object.values(responseDetails.paymentComponentBreakouts.filter(paymentBreakout => ['MONTHLY_ESCROW', 'MONTHLY_ESCROW_SHORTAGE', 'MONTHLY_P_AND_I', 'MONTHLY_TOTAL', 'OPTIONAL_PROD'].some(type => paymentBreakout.type === type))).sort((a, b) => orderBy[a.type] - orderBy[b.type]);
    return {
      effectiveDate: responseDetails.currentAnalysis.effectiveDate,
      optionOneAmount: responseDetails.monthlyPaymentAmountOption1,
      optionTwoAmount: responseDetails.monthlyPaymentAmountOption2,
      shortageOrSurplusAmount: responseDetails.currentAnalysis.shortageOrSurplusAmount,
      shortageSpread: responseDetails.currentAnalysis.shortageSpread,
      breakouts
    };
  }
  return {
    effectiveDate: 'NA',
    optionOneAmount: undefined,
    optionTwoAmount: undefined,
    shortageOrSurplusAmount: undefined,
    shortageSpread: undefined,
    breakouts: []
  };
};
export { useEscrowDetailsQuery, escrowSummaryEntityAdapter };
//# sourceMappingURL=index.js.map